module.exports = __webpack_public_path__ + "static/img/high-pressure-laminate-wayside-exhibits.59121fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/view-our-work/high-pressure-laminate-wayside-exhibits.jpg
// module id = 434
// module chunks = 0